import { styled, TypographyProps } from "@mui/material";

const EditableContent = styled("div")<TypographyProps>(({ theme }) => ({
    padding: theme.spacing(2, 0, 2, 2),
    outline: "none",
}));

export default EditableContent;
